module.exports = __webpack_public_path__ + "static/media/BuyACoffee.b581389f.png";